<template>
    <v-flex>
        <ChapterWaiverBanner></ChapterWaiverBanner>
        <v-flex
            md10
            lg9
            mx-auto
            class="waiver-block regional-officer"
            my-5>
            <v-card class="panelBlock">
                <v-flex xs12>
                    <v-flex tag="h2">{{chapterWaiverConstants.PROSPECTIVE_MEMBER_WAIVERS}}</v-flex>
                </v-flex>
                <v-flex
                    data-qe-id="regional_Waivers_showAll_link"
                    v-if="!isWaiverList"
                    class="show-all-waivers__link"><span class="ypo_blue_color" @click="ShowAllWaiver()">{{chapterWaiverConstants.VIEW_ALL_WAIVERS}}</span></v-flex>
                <div v-infinite-scroll="getListOfWaiversRegionalView" :infinite-scroll-distance="2000">
                    <v-flex
                        class="prospective-member"
                        v-for="(prospectData,i) in listOfWaivers"
                        :key="i">
                        <WaiverFormCommon 
                            :prospect="prospectData"
                            :sequence="i"
                            :leadId="leadId"
                            :isRegionalOfficer="true"
                            @showReasonDialogBox="showReasonDialogBox"/>
                        <v-flex
                            xs12
                            sm3
                            md3
                            text-sm-right
                            class="prospective-member__success_Message"
                            v-if="check(prospectData.id) && commentSavedSuccessMessage">
                            {{commentSavedSuccessMessage}}
                        </v-flex>
                    </v-flex>
                    <v-flex>
                        <v-dialog
                            v-model="showCommentsDialogBox"
                            scrollable
                            persistent
                            content-class="small">
                            <regional-officer-comments :lead-id="leadId" :close-dialog-box="hideReasonDialogBox"></regional-officer-comments>
                        </v-dialog>
                    </v-flex>
                    <v-flex
                        class="prospective-member__loading"
                        v-if="loadAction.pending"
                        justify-center
                        text-xs-center>
                        <v-progress-circular indeterminate color="grey"></v-progress-circular>
                    </v-flex>
                    <v-flex
                        class="prospective-member__loading"
                        v-else-if="loadAction.failed"
                        justify-center
                        text-xs-center>
                        {{chapterWaiverConstants.ERROR_LOADING}}
                    </v-flex>
                    <v-flex
                        class="prospective-member__loading"
                        v-else-if="!loadAction.pending && listOfWaivers && !(listOfWaivers.length > 0)"
                        justify-center
                        text-xs-center>
                        {{chapterWaiverConstants.WAIVER_LIST_EMPTY}}
                    </v-flex>
                </div>
            </v-card>
        </v-flex>
    </v-flex>
</template>

<script>
    import { appCommonConstants } from "../appCommon.constants";
    import ChapterWaiverBanner from "./ChapterWaiverBanner";
    import WaiverFormCommon from "./WaiverFormCommon";
    import { chapterWaiverConstants } from "./ChapterWaiver.constants";
    import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import RegionalOfficerComments from "./RegionalOfficerComments";
    import { headerConstant } from "../Header/header.constant";

    export default {
        name: "RegionalMemberOfficer",
        components: {
            ChapterWaiverBanner,
            WaiverFormCommon,
            RegionalOfficerComments,
        },
        created() {
            this.getWaiverQuestions();
            this.setVisibleProspect(null);
            this.getWaiverTypes();
            this.getTitleTypes();
        },
        data: () => {
            return {
                chapterWaiverConstants,
                appCommonConstants,
                getListWaiverInProgress: false,
                showCommentsDialogBox: false,
                headerConstant,
                leadId: '',
                waiverId: headerConstant.EMPTY_GUID,
                commentSavedSuccessMessage: '',
            };
        },
        methods: {
            ...mapActions({
                getWaiverQuestions: `chapterWaiver/${storeAction.getWaiverQuestions}`,
                getWaiverDetails: `chapterWaiver/${storeAction.getWaiverDetails}`,
                getListOfWaivers: `chapterWaiver/${storeAction.getListOfWaivers}`,
                getWaiverTypes: `chapterWaiver/${storeAction.getWaiverTypes}`,
                getTitleTypes: `chapterWaiver/${storeAction.getTitleTypes}`,
            }),
            ...mapMutations({
                setVisibleProspect: `chapterWaiver/${storeMutation.setVisibleProspect}`,
                resetChapterWaiverList: `chapterWaiver/${storeMutation.resetChapterWaiverList}`,
            }),
            isWaiverVisible(index) {
                return this.visibleProspect === index;
            },
            getListOfWaiversRegionalView() {
                if (this.$route && this.$route.query && this.$route.query.leadId) {
                    this.waiverId = this.$route.query.leadId;
                }
                if (!this.disableWaiverListInfiniteScroll && !this.getListWaiverInProgress) {
                    this.getListWaiverInProgress = true;
                    const communityId = this.$route.params && this.$route.params.communityId ? this.$route.params.communityId : null;
                    const viewType = this.chapterWaiverConstants.REGIONALOFFICER;
                    const req = {
                        communityId,
                        viewType,
                        leadId: this.waiverId || this.headerConstant.EMPTY_GUID,
                    };
                    this.getListOfWaivers(req)
                        .then(() => {
                            this.getListWaiverInProgress = false;
                        });
                }
            },
            showReasonDialogBox(res) {
                this.leadId = res.leadId;
                this.showCommentsDialogBox = res.showCommentsDialogBox;
            },
            hideReasonDialogBox() {
                this.showCommentsDialogBox = false;
            },
            showSuccessMessage() {
                this.commentSavedSuccessMessage = "Comment saved Successfully";
                setTimeout(() => { this.commentSavedSuccessMessage = ''; }, this.chapterWaiverConstants.MAX_TIMEOUT);
            },
            check(Id) {
                return this.leadId === Id;
            },
            disableCommentButton(waiverFlowStatus) {
                if (waiverFlowStatus && waiverFlowStatus.toLowerCase() === this.chapterWaiverConstants.SEND_TO_PRP.toLowerCase()) {
                    return true;
                }
                return false;
            },
            ShowAllWaiver() {
                this.waiverId = this.headerConstant.EMPTY_GUID;
                this.resetChapterWaiverList();
                this.$router.push({
                    path: `/regionalWaiver/${this.$route.params.communityId}`,
                });
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                disableWaiverListInfiniteScroll: `chapterWaiver/${storeGetters.disableWaiverListInfiniteScroll}`,
                visibleProspect: `chapterWaiver/${storeGetters.visibleProspect}`,
                waiverDetails: `chapterWaiver/${storeGetters.waiverDetails}`,
                listOfWaivers: `chapterWaiver/${storeGetters.listOfWaivers}`,
                regionalCommentSaved: `chapterWaiver/${storeGetters.regionalCommentSaved}`,
            }),
            loadAction() {
                return this.actions[storeAction.getListOfWaivers];
            },
            isWaiverList() {
                return this.waiverId === this.headerConstant.EMPTY_GUID;
            },
        },
    };
</script>

<style lang="scss">
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/responsive.scss';

    .show-all-waivers {
        &__link {
            padding: 14px 10px 0 10px;
            position: absolute;
            right: 10px;
            top: 0;

            span {
                text-decoration: underline;
                font-weight: 600;
                cursor: pointer;
            }

            @include breakpoint(xs) {
                position: relative;
                text-align: center;
                top: 0;
                right: 0;
                padding: 15px 0;
            }

        }
    }

    .regional-officer {
        .prospective-member {
            &__list-item {
                border-bottom: 1px solid $ypo-tile-border;
                align-items: center;
                padding: 10px 15px;

                &__view {
                    font-weight: bold;

                    span {
                        display: block;
                        color: $ypo-gray-text;
                        font-family: Raleway, serif;
                    }

                    .waiver-date {
                        color: $ypo-gray-text;
                        font-family: Raleway;
                        font-size: 12px;
                    }

                    i {
                        color: $ypo-cta;
                        cursor: pointer;
                    }
                }

                .success-text {
                    color: $ypo-green;
                }

                .failure-text {
                    color: $ypo-red;
                }
            }
        }

        @include breakpoint(xs) {
            margin: 15px 10px !important;

            .prospective-member {
                &__list-item {
                    &__view {
                        display: inherit;
                        align-items: center;

                        span {
                            max-width: inherit;
                            min-width: 91px;
                        }
                    }
                }
            }
        }
    }
</style>
